/**
 * Created by AlexanderC on 6/16/15.
 */

'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LocalStorageDriver = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _AbstractDriver2 = require('./AbstractDriver');

var _store = require('store');

var _store2 = _interopRequireDefault(_store);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * In memory driver implementation
 */
let LocalStorageDriver = exports.LocalStorageDriver = function (_AbstractDriver) {
  _inherits(LocalStorageDriver, _AbstractDriver);

  function LocalStorageDriver() {
    _classCallCheck(this, LocalStorageDriver);

    return _possibleConstructorReturn(this, (LocalStorageDriver.__proto__ || Object.getPrototypeOf(LocalStorageDriver)).call(this));
  }

  /**
   * @returns {String}
   * @private
   */


  _createClass(LocalStorageDriver, [{
    key: '_type',
    value: function _type() {
      return 'LocalStorage';
    }

    /**
     * @param {String} key
     * @param {Function} callback
     */

  }, {
    key: '_has',
    value: function _has(key) {
      let callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : () => {};

      callback(null, LocalStorageDriver._isAlive(_store2.default.get(key), key));
    }

    /**
     * @param {String} key
     * @param {Function} callback
     */

  }, {
    key: '_get',
    value: function _get(key) {
      let callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : () => {};

      let record = _store2.default.get(key);

      callback(null, LocalStorageDriver._isAlive(record, key) ? record.value : null);
    }

    /**
     * @param {String} key
     * @param {*} value
     * @param {Number} ttl
     * @param {Function} callback
     */

  }, {
    key: '_set',
    value: function _set(key, value) {
      let ttl = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
      let callback = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : () => {};

      let exd = ttl > 0 ? LocalStorageDriver._now + ttl : null;

      try {
        _store2.default.set(key, { value: value, exd: exd });
        callback(null, true);
      } catch (error) {
        if (this._isQuotaExceededError(error) && this._flushStale()) {
          this._set(key, value, ttl, callback);
        }

        callback(error, false);
      }
    }

    /**
     * @param {String} key
     * @param {Number} timeout
     * @param {Function} callback
     */

  }, {
    key: '_invalidate',
    value: function _invalidate(key) {
      let timeout = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      let callback = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : () => {};

      if (timeout <= 0) {
        _store2.default.remove(key);

        callback(null, true);

        return;
      }

      try {
        let record = _store2.default.get(key);

        record.exd = LocalStorageDriver._now + timeout;

        _store2.default.set(key, record);
      } catch (e) {
        // do nothing...
      }

      callback(null, true);
    }

    /**
     * @param {Function} callback
     */

  }, {
    key: '_flush',
    value: function _flush() {
      let callback = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : () => {};

      _store2.default.clear();

      callback(null, true);
    }

    /**
     * @returns {boolean}
     * @private
     */

  }, {
    key: '_flushStale',
    value: function _flushStale() {
      let keysToRemove = [];

      _store2.default.forEach((key, val) => {
        // @note - do not remove keys from cache at iteration time, it breaks the loop
        if (this.isDeepKey(key) && !LocalStorageDriver._isAlive(val, key, false) || this._getKeyBuildId(key) !== this._buildId) {
          keysToRemove.push(key);
        }
      });

      keysToRemove.forEach(key => {
        _store2.default.remove(key);
      });

      return keysToRemove.length > 0;
    }

    /**
     * @see http://chrisberkhout.com/blog/localstorage-errors/
     *
     * @param {Object} error
     * @returns {Boolean}
     * @private
     */

  }, {
    key: '_isQuotaExceededError',
    value: function _isQuotaExceededError(error) {
      let quotaExceededErrors = ['QuotaExceededError', 'QUOTA_EXCEEDED_ERR', 'NS_ERROR_DOM_QUOTA_REACHED'];

      return quotaExceededErrors.indexOf(error.name) !== -1;
    }

    /**
     * @returns {Number}
     * @private
     */

  }], [{
    key: '_isAlive',


    /**
     *
     * @param {Object} response
     * @param {String} key
     * @param {Boolean} removeStale
     * @returns {Boolean}
     * @private
     */
    value: function _isAlive(response, key) {
      let removeStale = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      if (!response) {
        return false;
      }

      if (response.exd && response.exd <= LocalStorageDriver._now) {
        if (removeStale) {
          _store2.default.remove(key);
        }
        return false;
      }

      return true;
    }

    /**
     * Checks for browser local storage availability
     *
     * @returns {boolean}
     */

  }, {
    key: 'isAvailable',
    value: function isAvailable() {
      return _store2.default.enabled;
    }
  }, {
    key: '_now',
    get: function get() {
      return parseInt(new Date().getTime() / 1000);
    }
  }]);

  return LocalStorageDriver;
}(_AbstractDriver2.AbstractDriver);


//////////////////
// WEBPACK FOOTER
// ../~/deep-cache/lib.compiled/Driver/LocalStorageDriver.js
// module id = 353
// module chunks = 0